import logo from "../logo192.png"; // 1. 画像をインポートする

const Title = (props) => {
  return (
    <div className="flex__row">
      <img src={logo} width={36} height={36} />
      <h2>{props.title}</h2>
    </div>
  );
};
export default Title;
